import Joi from 'joi';
import blockAppearanceSchema from '@utils/validate/blocksSchemes/blockAppearanceSchema';
import imageWithMetaDataSchema from '@utils/validate/blocksSchemes/imageWithMetadataSchema';
const MultiIconSchema = Joi.object({
  type: Joi.string().valid('multiIcon').required(),
  code: Joi.string().allow('', null).required(),
  title: Joi.string().allow('', null).required(),
  description: Joi.string().allow('', null).required(),
  color: Joi.string().allow('', null).required(),
  icons: Joi.array().items(Joi.object({
    icon: Joi.string().allow('', null).required(),
    text: Joi.string().allow('', null).required(),
    variant: Joi.string().allow('left', 'center', 'right'),
    hex: Joi.string().allow('', null),
    image: [imageWithMetaDataSchema, Joi.allow(null)],
    border: Joi.boolean().allow(null),
    isImageIcon: Joi.boolean()
  })),
  ...blockAppearanceSchema
}).unknown(true);
export default MultiIconSchema;